import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetGetListingManagment, IResponseGetGetListingManagment } from "./types"
import { GetListingManagmentUrl } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getGetListingManagment(
	{ ...rest }: IPropsGetGetListingManagment,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetGetListingManagment> =
			await apiPrivate.get(`${GetListingManagmentUrl}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetGetListingManagment(
	data: IPropsGetGetListingManagment,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetGetListingManagment,
					unknown,
					IResponseGetGetListingManagment
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETCALENDERDATA, ...Object.values(data)],
		queryFn: () => getGetListingManagment(data, apiPrivate),
		...options,
	})
}
